import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import Avatar from "react-avatar";
import { NotificationActions } from "../../actions";
import Loader from "../../components/common/Loader/Loader";
import styles from "./Alert.module.scss";
import { Link, useSearchParams } from "react-router-dom";
import parse from "html-react-parser";
import NoDataFond from "../../components/common/noDatafound/noDataPage";

const AlertsData = () => {
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.notification);
  const [searchParams, setSearchParams] = useSearchParams();
    const [isClicked, setIsClicked] = useState(
      localStorage.getItem("isClicked") || null
    );
  const selElement = document.getElementById("selectedMsg");

 



  useEffect(() => {
    dispatch(NotificationActions.getNotification());
    dispatch(NotificationActions.readNotification());
 
   const clickedCardId = localStorage.getItem("isClicked");
   if (clickedCardId) {
   setIsClicked(clickedCardId);
   }

    setTimeout(() => {
      if (searchParams) {
        searchParams.delete('profileId');
        searchParams.delete('jobId');
        setSearchParams(searchParams)
      }
    }, 300);

    
  }, []);



   const handleCardClick = (cardData) => {
     if (cardData.seen === false && cardData.id) {
       localStorage.setItem("isClicked", cardData.id);
       dispatch(NotificationActions.getNotificationStatus(cardData.id));
     }
     localStorage.setItem("isClicked", cardData.id);
    setIsClicked(cardData.id);
   };

   useEffect(() => {
     const handleBeforeUnload = () => {
       localStorage.removeItem("isClicked");
     };
     window.addEventListener("beforeunload", handleBeforeUnload);
     return () => {
       window.removeEventListener("beforeunload", handleBeforeUnload);
     };
   }, []);

     useEffect(() => {
       scrollToMsgDiv();
     }, [selElement]);
  

     const scrollToMsgDiv = () => {
        const divElement = document.getElementById("selectedMsg");
        if (divElement) {
        divElement.scrollIntoView({ behavior: "smooth", block: "center"});          
        }
     }

  return (
    <>
      {notification?.notificationLoader ? (
        <Loader color={"#5382ba"} />
      ) : (
        <div className={styles.AlertPage}>
          <Container>
            <div className={styles.alertMain}>
              {notification?.notificationData &&
              notification?.notificationData.length > 0 ? (
                notification?.notificationData.map((data, i) => (
                  <>
                    <Card key={i} className={styles.alertsCard}>
                      <CardTitle className={styles.alertsCardTitle}>
                        <div className={styles.historyDatePart}>
                          {data.date}
                        </div>
                      </CardTitle>
                      <CardBody className={styles.alertsBody}>
                        {data?.data?.map((val, ind) =>
                          val?.message && val?.message !== "" ? (
                            <>
                              {val?.applicationId !== null ||
                              val?.isKanbanUpdate ||
                              val?.type === "JOB_ASSIGNMENT" ? (
                                <Link
                                  key={ind}
                                  to={
                                    val?.jobProfileId &&
                                    val?.jobId &&
                                    `/applicants?profileId=${val?.jobProfileId}&jobId=${val?.jobId}&tab=applications`
                                  }
                                  state={{
                                    applicationId: val?.applicationId,
                                    commentId: val?.commentId,
                                    tagged: val?.commentId ? true : false,
                                    isKanbanUpdate: val?.isKanbanUpdate,
                                    returnAlert: true,
                                  }}
                                >
                                  <Row
                                    className={`${styles.hostoryRow} ${
                                      val?.read === false ? styles.unread : ""
                                    }`}
                                  >
                                    <Col
                                      md="10"
                                      sm="10"
                                      className="py-2 rounded"
                                      id={isClicked === val.id.toString() ? 'selectedMsg' : ''}
                            
                                      onClick={() => handleCardClick(val)}
                                      style={{
                                        backgroundColor:
                                          isClicked === val.id.toString()
                                            ? "lightBlue"
                                            : val.seen
                                            ? "white"
                                            : "lightGray",
                                      }}
                                    >
                                      <div className={styles.historyNamePart}>
                                        <div
                                          className={`${styles.profileImage}`}
                                        >
                                          {val?.avtar && val?.avtar?.url ? (
                                            <Avatar
                                              className={styles.commentAvt}
                                              facebook-id="invalidfacebookusername"
                                              src={val?.avtar?.url}
                                              size="30"
                                              round={true}
                                            />
                                          ) : (
                                            <Avatar
                                              className={styles.commentAvt}
                                              name={
                                                val?.name + " " + val?.lastName
                                              }
                                              maxInitials={2}
                                              size="30"
                                              round={true}
                                            />
                                          )}
                                        </div>
                                        <div className={styles.StatusText}>
                                          <span className={styles.pName}>
                                            {val?.name}{" "}
                                            {val?.lastName != null
                                              ? val?.lastName
                                              : ""}
                                          </span>{" "}
                                          {parse(val?.message)}
                                        </div>
                                      </div>
                                    </Col>
                                    <Col md="2" sm="2">
                                      <div className={styles.historyDataPart}>
                                        <div className={styles.HistoryTime}>
                                          {val?.createdTime}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Link>
                              ) : (
                                <Link
                                  key={ind}
                                  to={
                                    val?.jobProfileId &&
                                    val?.jobId &&
                                    `/applicants?profileId=${val?.jobProfileId}&jobId=${val?.jobId}&commentId=${val?.commentId}&tab=announcement`
                                  }
                                >
                                  <Row
                                    className={`${styles.hostoryRow} ${
                                      val?.read === false ? styles.unread : ""
                                    }`}
                                  >
                                    <Col md="10" sm="10">
                                      <div className={styles.historyNamePart}>
                                        <div
                                          className={`${styles.profileImage}`}
                                        >
                                          {val?.avtar && val?.avtar?.url ? (
                                            <Avatar
                                              className={styles.commentAvt}
                                              facebook-id="invalidfacebookusername"
                                              src={val?.avtar?.url}
                                              size="30"
                                              round={true}
                                            />
                                          ) : (
                                            <Avatar
                                              className={styles.commentAvt}
                                              name={
                                                val?.name + " " + val?.lastName
                                              }
                                              maxInitials={2}
                                              size="30"
                                              round={true}
                                            />
                                          )}
                                        </div>

                                        <div className={styles.StatusText}>
                                          <span className={styles.pName}>
                                            {val?.name}{" "}
                                            {val?.lastName != null
                                              ? val?.lastName
                                              : ""}
                                          </span>{" "}
                                          {parse(val?.message)}
                                        </div>
                                      </div>
                                    </Col>
                                    <Col md="2" sm="2">
                                      <div className={styles.historyDataPart}>
                                        <div className={styles.HistoryTime}>
                                          {val?.createdTime}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Link>
                              )}
                            </>
                          ) : (
                            ""
                          )
                        )}
                      </CardBody>
                    </Card>
                  </>
                ))
              ) : (
                <NoDataFond />
              )}
            </div>
          </Container>
        </div>
      )}
    </>
  );
};

export default AlertsData;
